export default "__VITE_ASSET__1d9a3a95__"